// extracted by mini-css-extract-plugin
export var feedback = "sectionContactForm-module--feedback--b499c";
export var flex = "sectionContactForm-module--flex--ff8a6";
export var form = "sectionContactForm-module--form--0ba2e";
export var negative = "sectionContactForm-module--negative--649e8";
export var neutral = "sectionContactForm-module--neutral--ae9a5";
export var positive = "sectionContactForm-module--positive--63237";
export var richtext = "sectionContactForm-module--richtext--f0c50";
export var section = "sectionContactForm-module--section--334fd";
export var success = "sectionContactForm-module--success--305ae";
export var textOnLeft = "sectionContactForm-module--textOnLeft--4cd91";
export var wrapper = "sectionContactForm-module--wrapper--ef1e8";